import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import BasicModal from '../../../../components/modal/BasicModal';
import { abrirModalConfirmarReiniciar, fecharModalReiniciarOlt } from '../../redux/OltActions';

const ExibirModalReiniciarOlt = () => {
    const dispatch = useDispatch();

    const locales = useSelector(state => state.layoutState.linguagem);
    const defaultText = require(`../../nls/${locales}.json`);
    const statusModal = useSelector(state => state.oltsState.statusModal);
    const olt = useSelector(state => state.oltsState.olt);
    const oltLocal = useSelector((state) => state.authentication.user.aplicacaoLogado.nomeLocal);

    return (
        <BasicModal
            open={statusModal}
            close={() => dispatch(fecharModalReiniciarOlt())}
            containerModal={{
                title: defaultText.tituloModalReiniciar,
                size: 'medium',
                content: (
                    <>
                        <p>{defaultText.mensagem.reiniciar}
                            <span style={{ fontWeight: "bold" }}> {olt.nome} </span>
                            {defaultText.mensagem.in}
                            {oltLocal}
                        </p>
                    </>
                ),
                closeText: defaultText.btn.fechar,
                action: {
                    acao: () => dispatch(abrirModalConfirmarReiniciar(olt)),
                    texto: defaultText.btn.reiniciar,
                    class: "success"
                }
            }}
        />
    );
};

export default ExibirModalReiniciarOlt;
